export default {
    data() {
        return {
            hoverBlocked: false
        }
    },
    methods: {
        blockHover() {
            this.hoverBlocked = true
        },
        unblockHover() {
            this.hoverBlocked = false
        }
    }
}



// WEBPACK FOOTER //
// ./src/mixin/blockHover.js